import { jsx as _jsx } from "react/jsx-runtime";
import { Banknote, ClockAlert, Coins, HandCoins, Receipt, UserCheck, Users, Wallet, } from "lucide-react";
/**
 * The 8 KPI cards — presentation for the figures the API returns in `cards`.
 *
 * The numbers are NOT derived from the rows on screen: the endpoint aggregates them
 * over the whole billing cycle for the month, before the filter bar narrows the
 * listing, so the cards stay put as the user filters. (The table's footer totals are
 * the opposite by design — they sum the visible rows.)
 *
 * Six of the eight report 0 until invoicing is integrated; the endpoint has no invoice
 * state to aggregate yet. Each tooltip states the rule the figure follows.
 */
const ICON_SIZE = 18;
/** Card icons are lucide glyphs — same treatment as the tracker report cards. */
export const buildSummaryCards = (cards) => [
    {
        key: "total_billing",
        title: "Total Billing",
        tooltip: "The sum of the Total Bill Amount for all clients.",
        format: "amount",
        icon: _jsx(Receipt, { size: ICON_SIZE }),
        value: cards.total_billing,
    },
    {
        key: "total_billable_clients",
        title: "Total Billable Clients",
        tooltip: "The total number of clients whose Total Bill Amount is greater than 0.",
        format: "number",
        icon: _jsx(Users, { size: ICON_SIZE }),
        value: cards.total_billable_clients,
    },
    {
        key: "total_amount_billed",
        title: "Total Amount Billed",
        tooltip: "The sum of the Total Bill Amount for all clients whose invoice has been sent.",
        format: "amount",
        icon: _jsx(Banknote, { size: ICON_SIZE }),
        value: cards.total_amount_billed,
    },
    {
        key: "total_amount_collected",
        title: "Total Amount Collected",
        tooltip: "The sum of the Total Bill Amount for all clients whose invoice status is Paid.",
        format: "amount",
        icon: _jsx(Wallet, { size: ICON_SIZE }),
        value: cards.total_amount_collected,
    },
    {
        key: "clients_billed",
        title: "# of Clients Billed",
        tooltip: "The total number of clients whose invoice has been sent.",
        format: "number",
        icon: _jsx(UserCheck, { size: ICON_SIZE }),
        value: cards.clients_billed,
    },
    {
        key: "clients_collected",
        title: "# of Clients Collected",
        tooltip: "The total number of clients whose invoice status is Paid.",
        format: "number",
        icon: _jsx(HandCoins, { size: ICON_SIZE }),
        value: cards.clients_collected,
    },
    {
        key: "amount_remaining",
        title: "Amount Remaining to Collect",
        tooltip: "Total Amount Billed − Total Amount Collected.",
        format: "amount",
        icon: _jsx(Coins, { size: ICON_SIZE }),
        value: cards.amount_remaining_to_collect,
    },
    {
        key: "clients_remaining",
        title: "# of Clients Remaining to Collect",
        tooltip: "# of Clients Billed − # of Clients Collected.",
        format: "number",
        // Overdue clock, not a "remove user" glyph — the card counts clients whose
        // payment is still outstanding, it doesn't subtract anyone.
        icon: _jsx(ClockAlert, { size: ICON_SIZE }),
        value: cards.clients_remaining_to_collect,
    },
];
